import fitvids from "fitvids";
import LazyLoad from "vanilla-lazyload";

const Common = {
  lazyLoadInstance: null,
  scrollbar: null,

  init() {
    this.lazyLoadInstance = new LazyLoad({
      callback_loaded: (el) => {
        el = $(el);
        el.closest(".lazy-wrapper").addClass("loaded");
      },
    });

    Common.events();
    Common.initScrollBar();
    Common.popup();
    Common.longerTitle();
  },

  scrollTo(offset, isEl = false) {
    if (!isEl) {
      offset -= 100;
    }

    if (this.scrollbar) {
      if (isEl) {
        this.scrollbar.scrollIntoView(offset);
      } else {
        this.scrollbar.scrollTo(0, offset, 500);
      }
    } else {
      if (isEl) {
        offset = $(offset).offset().top - 100;
      }

      $("html,body").animate({
        scrollTop: offset,
      });
    }
  },

  events() {
    // Scroll to element.
    $(".scroll-to").on("click", (e) => {
      const btnEl = $(e.currentTarget);
      const target = btnEl.data("target");

      let offset = "top" == target ? 0 : $(target).offset().top;

      this.scrollTo(offset);
    });

    // Scroll to element if hash link.
    $("a").on("click", (e) => {
      const link = $(e.currentTarget);

      const href = link.attr("href");

      if (!href.startsWith("#")) {
        return;
      }

      const el = $(href);

      if (!el.length) {
        return;
      }

      e.preventDefault();

      history.pushState(null, null, href);

      const offset = $(el).offset().top - 100;

      this.scrollTo(offset);
    });

    // Share link
    $(".share__link").on("click", (e) => {
      e.preventDefault();
      const btnEl = $(e.currentTarget);
      const url = btnEl.attr("href");

      if ("link" != btnEl.data("portal")) {
        window.open(url, "_blank", "width=786px,height=310px");
      } else {
        this.copyText(url)
          .then(() => {
            $(".share__list").addClass("hidden");
            $(".share__copied").removeClass("hidden");
          })
          .catch(() => console.log("error"));
      }
    });

    $(".share__toggle").on("click", (e) => {
      $(".share__list").removeClass("hidden");
      $(".share__copied").addClass("hidden");
    });

    // Table
    $(".entry-content table").wrap(
      '<div class="scrolltable"><div class="scrolltable__inner"></div></div>'
    );
    $(".scrolltable").scroll(function () {
      $(this).addClass("scrolled");
    });
  },

  copyText(textToCopy) {
    if (navigator.clipboard && window.isSecureContext) {
      // navigator clipboard api method'
      return navigator.clipboard.writeText(textToCopy);
    } else {
      // text area method
      let textArea = document.createElement("textarea");
      textArea.value = textToCopy;

      // make the textarea out of viewport
      textArea.style.position = "fixed";
      textArea.style.left = "-999999px";
      textArea.style.top = "-999999px";
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();

      return new Promise((res, rej) => {
        // here the magic happens
        document.execCommand("copy") ? res() : rej();
        textArea.remove();
      });
    }
  },

  initScrollBar() { },

  /**
   * Popup
   */
  popup() {
    const toggleEl = $("[data-popup-target]");

    // Toggle box.
    toggleEl.on("click", (e) => {
      const btnEl = $(e.currentTarget);
      const target = btnEl.data("popup-target");
      const targetEl = $(`[data-popup=${target}]`);
      targetEl.toggleClass("open");

      if (undefined != btnEl.data("popup-fullscreen")) {
        if (targetEl.hasClass("open")) {
          $("html").addClass("no-scroll");
        } else {
          $("html").removeClass("no-scroll");
        }
      }
    });

    // Close on ESC
    $(document).on("keyup", (e) => {
      const popupEL = $("[data-popup]:is(.open)");
      if (e.keyCode === 27 && popupEL.length) {
        popupEL.removeClass("open");
      }
    });

    // Close on click outside.
    $(document).mouseup(function (e) {
      const popupEL = $("[data-popup]:is(.open)");
      const wrapperEl = popupEL.parent();

      if (
        !wrapperEl.is(e.target) &&
        wrapperEl.has(e.target).length === 0 &&
        popupEL.length
      ) {
        popupEL.removeClass("open");
      }
    });
  },

  longerTitle() {
    const title = document.querySelector('.page-header__title');
    if (title) {

      const characterCount = title.textContent.length;

      if (characterCount > 40) {
        title.classList.add('longerText');
      }
    }

  }
};

export default Common;
